import { createSelector } from '@reduxjs/toolkit';

import { IState } from '../../store';

export const selectLegalInfo = createSelector(
  (state: IState) => state.offerData.legalInfo,
  legalInfo => legalInfo || null,
);
